import { injectMarketingEmbedNav } from 'marketplace-ui-common/html/injectMarketingEmbedNav';
import quickFetch from 'quick-fetch';
export function earlyRequester() {
  injectMarketingEmbedNav(/hubspotqa/.test(window.location.hostname) && window.location.search.includes('_marketingEmbedNavQa=true'));
  quickFetch.makeEarlyRequest('public-auth-check', {
    url: quickFetch.getApiUrl('/cookie-echo/v1/user'),
    type: 'GET',
    dataType: 'json',
    timeout: 2000,
    noPortalId: true,
    whenFinished: response => {
      if (isHubSpotEmail(response.email) && (!window.location.search.includes('_redirect=true') || window.location.search.includes('_healthCheck=true'))) {
        console.log('public-auth-check: skipping redirect');
        return;
      }

      /**
       * TODO: Disable redirect for INBOUND, uncomment after ungated to all customers
       */
      console.log('public-auth-check: would redirect');
      // const isQa = /hubspotqa/.test(window.location.hostname);
      // // eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
      // const appDomain = isQa ? 'app.hubspotqa.com' : 'app.hubspot.com';
      // const redirectPath = window.location.pathname.replace(
      //   /^.*\/marketplace/,
      //   ''
      // );
      // const redirectUrl = `https://${appDomain}/l/marketplace${redirectPath}${window.location.search}`;
      // window.location.replace(redirectUrl);
    }
  });
}

// Taken from: https://git.hubteam.com/HubSpotProtected/SecureCookies/blob/ef6924e336b1689cc2e644e92ac7c78fe35a39ca/AppCookieCore/src/main/java/com/hubspot/jersey/cookies/secure/app/issuers/AcceptanceTestIssuerIF.java#L18-L24
const HUBSPOT_EMAIL_DOMAINS = ['hubspot.com', 'p1.hubspotemailqa.com', 'internaltest.hubspotemail.net',
// Below email domains used with hublets, eg: na1.smoketests.hsemailsendingtest.com
// https://git.hubteam.com/HubSpot/faas-test-issues/issues/320#issuecomment-1673231
'smoketests.hsemailsendingtest.com', 'smoketests.hsemailsendingtestqa.com'];
function isHubSpotEmail(email) {
  const [__, userDomain] = email.split('@');
  return userDomain && (HUBSPOT_EMAIL_DOMAINS.some(domain => domain === userDomain) || HUBSPOT_EMAIL_DOMAINS.some(domain => userDomain.endsWith(`.${domain}`)));
}